{
  "exitAppPromptTitle": "Exit to Analytics Portal?",
  "exitAppPromptMessage": "You are about to leave FarmHQ and open the FarmHQ Analytics Portal in an external web browser."
}
